import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime } from 'rxjs/operators';
import { TrailerBaseDetails } from 'src/app/types';
import { TrailersService } from '../trailers.service';

@Component({
  selector: 'lohi-all-trailers',
  templateUrl: './all-trailers.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTrailersComponent implements OnInit {
  public displayedColumns: string[] = ['Trailer Number', 'Status', 'Owner'];
  public searchFormControl = new FormControl('');
  public dataSource: MatTableDataSource<TrailerBaseDetails>;

  constructor(private trailerService: TrailersService) {}

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource([]);
    this.trailerService.allTrailers$.subscribe((trailers) => {
      this.dataSource.data = trailers;
    });
    this.searchFormControl.valueChanges.pipe(debounceTime(200)).subscribe((searchText) => {
      this.dataSource.filter = searchText.trim().toLowerCase();
    });
  }
}
